import { useBulkExport } from '@/hooks/use-api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Database, ShieldCheck } from 'lucide-react';

export function ComplianceTab() {
  const bulkExport = useBulkExport();

  return (
    <Card className="overflow-hidden rounded-3xl border border-border bg-card shadow-2xl">
      <CardHeader className="border-b border-border bg-muted/30 p-10">
        <CardTitle className="flex items-center gap-3 text-2xl font-black uppercase tracking-tight text-foreground">
          <ShieldCheck className="h-7 w-7 text-primary" />Institutional Data Integrity
        </CardTitle>
        <CardDescription className="text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground">
          Full JSON export of all institutional data for compliance and disaster recovery.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-8 p-6 sm:p-10">
        <div className="group flex flex-col items-center justify-between gap-8 rounded-[2rem] border border-border bg-muted/50 p-6 transition-all hover:bg-muted/80 sm:flex-row sm:p-8">
          <div className="flex items-center gap-5">
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-primary/20 text-primary shadow-inner transition-transform group-hover:scale-110">
              <Database className="h-8 w-8" />
            </div>
            <div>
              <p className="text-xl font-black uppercase tracking-tight text-foreground">On-Demand System Backup</p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Clients, loans, transactions, and audit records.</p>
            </div>
          </div>
          <Button onClick={() => bulkExport()} className="h-14 w-full rounded-xl bg-primary px-10 font-black uppercase tracking-tight shadow-lg shadow-primary/20 hover:bg-primary/90 sm:w-auto">
            Generate Data Bundle
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
